/* eslint-disable import/prefer-default-export */
import React from "react";

export const benefitDuplicateConfig = {
  /* ---------------- PAGE CONFIG ---------------- */
  agentName: "Benefits Agent",
  title: "Benefits Report",
  subtitle: "Benefit Agent",
  backPath: "/benefit-agent",

  /* ---------------- TABLE DATA ---------------- */
  staticData: [
    {
      caseId: "2934",
      submitDate: "Aug 6, 2024",
      origin: "Website App",
      firstName: "Divya",
      lastName: "G. Mangova",
      caseManager: "Lisa Turner",
      updatedAt: "Dec 9, 2025 10:04 PM",
      notes: "84% partially",
    },
    {
      caseId: "2935",
      submitDate: "Aug 7, 2024",
      origin: "Mobile App",
      firstName: "John",
      lastName: "Doe",
      caseManager: "Anna Smith",
      updatedAt: "Dec 10, 2025 11:15 AM",
      notes: "100% partially",
    },
  ],

  /* ---------------- TABLE COLUMNS ---------------- */
  columns: [
    {
      header: (
        <div className="caseid-header">
          <span>Case ID</span>
        </div>
      ),
      accessor: "caseId",
      render: (value, row, _, onRowSelect) => (
        <div className="caseid-with-checkbox">
          <input
            type="checkbox"
            checked={onRowSelect?.selected?.some((r) => r.caseId === row.caseId)}
            onChange={() => onRowSelect(row)}
          />
          <span>{value}</span>
        </div>
      ),

    },
    { header: "Case Submit Date", accessor: "submitDate" },
    { header: "Intake Origin", accessor: "origin" },
    {
      header: "First Name",
      accessor: "firstName",
      render: (value) => (
        <div className="name-with-icon">
          <span className="circle-icon orange" />
          <span>{value}</span>
        </div>
      ),
    },
    {
      header: "Last Name",
      accessor: "lastName",
      render: (value) => (
        <div className="name-with-icon">
          <span className="circle-icon yellow" />
          <span>{value}</span>
        </div>
      ),
    },

    { header: "Case Manager", accessor: "caseManager" },
    { header: "Case Manager Updated", accessor: "updatedAt" },
    { header: "Notes", accessor: "notes" },
    {
      accessor: "tagAsPrimary",
      render: (_, row, onTagPrimary) => (
        <button
          type="button"
          className="tagAsPrimary-btn"
          onClick={onTagPrimary}
        >
          Tag as primary
        </button>
      ),
    },

  ],

  primaryApplColumns: [
    { header: "Case ID", accessor: "caseId" },
    { header: "Case Submit Date", accessor: "submitDate" },
    {
      header: "Intake Origin",
      accessor: "origin",
      render: (v) => <span className="pill blue">{v}</span>,
    },
    {
      header: "First Name",
      accessor: "firstName",
      render: (v) => (
        <span>
          <span className="dot blue" />
          {' '}
          {v}
        </span>
      ),
    },
    {
      header: "Last Name",
      accessor: "lastName",
      render: (v) => (
        <span>
          <span className="dot blue" />
          {' '}
          {v}
        </span>
      ),
    },
    {
      header: "Case Manager",
      accessor: "caseManager",
      render: (v) => <span className="pill green">{v}</span>,
    },
    {
      header: "Case Manager Updated",
      accessor: "caseManagerUpdated",
      render: (v) => (
        <>
          <div className="primary-text">{v?.date}</div>
          <div className="secondary-text">{v?.time}</div>
        </>
      ),
    },
    // {
    //   header: "Wellness Status",
    //   accessor: "wellnessStatus",
    //   render: (v) => <span className="pill green">{v}</span>,
    // },
    // {
    //   header: "Wellness Status Updated",
    //   accessor: "wellnessUpdated",
    // },
    {
      header: "Notes",
      accessor: "notes",
    },
  ],

  primaryApplData: [
    {
      caseId: "2028",
      submitDate: "Aug 8, 2024",
      origin: "Website App",
      firstName: "Sharma",
      lastName: "G. Manopavan",
      caseManager: "Assigned",
      caseManagerUpdated: {
        date: "Dec 11, 2025",
        time: "11:34 PM",
      },
      wellnessStatus: "In-progress",
      wellnessUpdated: "Dec 11, 2025",
      notes: "98% Complete",
    },
    {
      caseId: "2029",
      submitDate: "Aug 9, 2024",
      origin: "Website App",
      firstName: "Amit",
      lastName: "Kumar",
      caseManager: "Assigned",
      caseManagerUpdated: {
        date: "Dec 11, 2025",
        time: "10:18 AM",
      },
      wellnessStatus: "In-progress",
      wellnessUpdated: "Dec 11, 2025",
      notes: "96% Complete",
    },
    {
      caseId: "2030",
      submitDate: "Aug 10, 2024",
      origin: "Mobile App",
      firstName: "Rohit",
      lastName: "Singh",
      caseManager: "Assigned",
      caseManagerUpdated: {
        date: "Dec 10, 2025",
        time: "09:02 PM",
      },
      wellnessStatus: "In-progress",
      wellnessUpdated: "Dec 10, 2025",
      notes: "94% Complete",
    },
    {
      caseId: "2031",
      submitDate: "Aug 11, 2024",
      origin: "Website App",
      firstName: "Neha",
      lastName: "Verma",
      caseManager: "Assigned",
      caseManagerUpdated: {
        date: "Dec 9, 2025",
        time: "06:45 PM",
      },
      wellnessStatus: "In-progress",
      wellnessUpdated: "Dec 9, 2025",
      notes: "92% Complete",
    },
    {
      caseId: "2032",
      submitDate: "Aug 12, 2024",
      origin: "Mobile App",
      firstName: "Pooja",
      lastName: "Sharma",
      caseManager: "Assigned",
      caseManagerUpdated: {
        date: "Dec 8, 2025",
        time: "03:30 PM",
      },
      wellnessStatus: "In-progress",
      wellnessUpdated: "Dec 8, 2025",
      notes: "90% Complete",
    },
    {
      caseId: "2033",
      submitDate: "Aug 13, 2024",
      origin: "Website App",
      firstName: "Vikas",
      lastName: "Tiwari",
      caseManager: "Assigned",
      caseManagerUpdated: {
        date: "Dec 7, 2025",
        time: "01:12 PM",
      },
      wellnessStatus: "In-progress",
      wellnessUpdated: "Dec 7, 2025",
      notes: "88% Complete",
    },
    {
      caseId: "2034",
      submitDate: "Aug 14, 2024",
      origin: "Mobile App",
      firstName: "Anjali",
      lastName: "Gupta",
      caseManager: "Assigned",
      caseManagerUpdated: {
        date: "Dec 6, 2025",
        time: "11:05 AM",
      },
      wellnessStatus: "In-progress",
      wellnessUpdated: "Dec 6, 2025",
      notes: "86% Complete",
    },
  ],
};
